<template>
  <div
    class="column landing_buy_blu_buy p0 h100"
    :class="{ selectWay: selectWay, modalWarning: modalWarning }"
  >
    <div class="loading h100" v-if="!loading" style="color: #4a4a4a !important">
      <div class="column main_blue_dk_bg border-radius-8 buy-blue-header">
        <h1 class="component_title_md fat border-radius-8" style="color: white">
          {{ $t("msg.buy_tokens") }}
        </h1>

        <h1
          class="component_title_md fat tal_c"
          style="color: white"
          v-if="stepForm && !formFinish"
        >
          OTC - {{ $t("msg.fill_form") }}
        </h1>
        <h1
          class="component_title_md fat tal_c"
          style="color: white"
          v-if="formFinish"
        >
          {{ $t("msg.thank_you") }}
        </h1>
      </div>

      <div
        class="column container_buyblue_mobile"
        v-if="
          !selectWay &&
          !modalWarning &&
          !stepForm &&
          !formFinish &&
          !stepSellerInfoUid
        "
      >
        <div class="column columns p10t">
          <div class="column">
            <p>{{ $t("msg.beforeSendUnderTitle") }}</p>
          </div>
        </div>


        <div style="color:#de350b; text-align: center;" v-if="blockMsg">
          <p>{{ $t("msg.blockMsgP") }}</p>
        </div>

        <div class="column columns">
          <div class="column noselect" style="padding: 0rem !important">
            <div
              class="column p0 blu_input_container"
              v-bind:class="{
                has_error: parseFloat(bluAmount) < parseFloat(minBlue),
              }"
            >
              <img
                class="blu_input_img"
                src="../../../../assets/images/blue_icon.svg"
              />
              <div class="blu_input">
                <input
                  v-model="bluAmount"
                  :placeholder="'min. ' + minBlue + ' Blu'"
                  v-on:keypress="isNumber()"
                />
              </div>
              <div class="blu_input_actions">
                <div class="blu_input_plus" @click="modifyBluAmount('+')">
                  <p v-html="iconSets.general_up"></p>
                </div>
                <div
                  class="blue_input_minus"
                  @click="modifyBluAmount('-')"
                  v-bind:class="{
                    arrow_disabled:
                      parseFloat(bluAmount) <= parseFloat(minBlue),
                  }"
                >
                  <p v-html="iconSets.general_down"></p>
                </div>
              </div>
            </div>

            <div>
              <p
                class="text_sm tal_c"
                v-bind:class="{
                  has_error_text: parseFloat(bluAmount) < parseFloat(minBlue),
                }"
              >
                {{ $t("msg.amount") }} {{ $t("msg.min") }}: {{ minBlue }} BLUE
                ({{ getMinBluXUsdt() }} USDT)
                <span v-if="minBlue == 0.01">
                  <br />
                  <strong
                    >( this value applies for your test account only.)</strong
                  >
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="column split_half_text" v-if="btcAccount">
          <div class="column split_half_text">
            <div class="column p0 split_half_text">
              <p
                id="amount_before_fees_"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <span class="tal_l">{{ $t("msg.subtotal") }}:</span>
                <span class="tal_r"
                  >{{
                    (bluValue[0].value * bluAmount) | decimalsCrypto(2)
                  }}
                  USDT</span
                >
              </p>
              <div class="component_border_bottom">
                <span></span>
              </div>
            </div>
          </div>
          <p
            class="ft_small"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <span style="width: 70%">
              <strong
                >{{ $t("msg.load_fee") }} <br />
                ( {{ 2 | percentage(2) }} )</strong
              >
            </span>
            <span class="tal_r" style="width: 28%"
              >{{
                ((bluValue[0].value * bluAmount * 2) / 100) | decimalsCrypto(2)
              }}
              USDT</span
            >
          </p>
          <div class="component_border_bottom">
            <span></span>
          </div>
          <p
            class="text_xl ft_small"
            style="display: flex; justify-content: space-between"
          >
            <span class="val_t">
              <strong>{{ $t("msg.total_to_transfer", 1) }}</strong>
            </span>
            <span class="tal_r val_sub">
              <b
                >{{
                  (bluTusd =
                    (bluValue[0].value * bluAmount * 2) / 100 +
                    bluValue[0].value * bluAmount) | decimalsCrypto(2)
                }}
                USDT</b
              >
            </span>
          </p>
        </div>

        <div class="column">
          <button
            id="pay_with_btc"
            class="
              sub_green_lt_bg
              component_super_button
              sub_green_lt_bg_hover
              upper
              text_lg
            "
            style="border-radius: 10px; padding: 20px"
            @click="blockPurchaseInfo()"
          >
            {{ $tc("msg.buy_token", 1) }}
          </button>
        </div>

        <!-- <div class="column flex_contant_center">
          <span class="fat sub_blue_md_fill">{{$tc("msg.we_accet",1)}},</span>
          <div class="accept_cont fat">
            <span class="upper">{{$tc('msg.criptocurrency')}}</span> |
            <i class="icon_class_4" v-html="iconSets.visa_blu"></i> |
            <i class="icon_class_4" v-html="iconSets.master_card"></i>
          </div>
        </div> -->
        <label class="text_sm" v-html="$t('msg.below_button_1')"></label>
        <br />
      </div>

      <div
        class="buy_blu_modal_select_way"
        v-if="selectWay && !stepSellerInfoUid"
        style="height: 900px; background: Red"
      >
        <div class="column p0" v-if="paymentMode == 'crypto'">
          <div
            class="container_select_partners"
            @click="changeModalWarningState(true, 'crypto')"
          >
            <!-- <div class="column m0 p0 tal_c">
              <p style="display:block" class="best_way_tag">{{$tc('msg.best_way_buy')}}</p>
            </div> -->
            <div class="columns column m0 p0">
              <div class="column p0">
                <img
                  src="../../../../assets/images/buycrypto_transfer_button.svg"
                />
              </div>
              <div class="column p0 custom-flex">
                <div class="sub_container m_auto">
                  <img src="../../../../assets/images/crypto_icon.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="buy_blu_modal_warning"
        v-if="modalWarning && !stepSellerInfoUid"
        style="
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        "
      >
        <h1 class="component_title_md fat tal_c fs_18r" style="color: white">
          {{ $t("msg.select_coin_payment") }}
        </h1>

        <div class="column custom_flex_column p0 m10_t">
          <div class="m12_t">
            <div
              class="container_coin_select_buy"
              :class="{
                selected: selectedCurrency == currency.symbol,
                coin_disabled: !currency.isAvailable,
              }"
              v-for="currency in currencyList"
              :key="currency.symbol"
              @click="selectCurrency(currency.symbol)"
            >
              <img :src="currency.img" class="buy_coin_icon" alt="icon" />
              <div style="width: 100%">
                <div
                  v-if="currency.symbol == 'USDT'"
                  style="
                    display: flex;
                    justify-items: center;
                    align-items: flex-start;
                    flex-direction: column;
                  "
                >
                  <div
                    style="
                      display: flex;
                      justify-items: center;
                      align-items: center;
                      justify-content: space-between;
                      width: 100%;
                    "
                  >
                    <p class="dis_inb capitalize fs_18r fat">
                      {{ currency.name }}
                    </p>
                    <div
                      style="display: flex; align-items: center"
                      v-if="usdtAccount.balance"
                    >
                      <div
                        class="icon_class_1"
                        v-html="iconSets.general_wallet_white"
                      ></div>
                      <p style="margin-left: 10px">
                        {{ usdtAccount.balance | decimalsCrypto(6) }}
                        {{ currency.symbol }}
                      </p>
                    </div>
                  </div>
                  <p class="dis_inb fs_small">
                    {{ $t("msg.tether_info") }}
                  </p>
                </div>
                <div
                  v-else
                  style="
                    display: flex;
                    justify-items: center;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <p class="dis_inb capitalize fs_18r fat">
                    {{ currency.name }}
                  </p>
                </div>
                <!-- <br /> -->
                <p class="dis_inb fs_small" v-if="currency.symbol == 'ETH'">
                  {{ $t("msg.eth_contract_message") }}
                </p>
                <!-- <p class="dis_inb fs_small" v-if="currency.symbol == 'USDT'">
                  {{ $t("msg.tether_info") }}
                </p> -->
              </div>
            </div>

            <div class="container_coin_select_buy" @click="showModalPIX()">
              <img
                class="buy_coin_icon"
                src="../../../../assets/images/coins/pix-buyBlue.svg"
                alt="icon"
              />

              <div style="font-size: 13px !important">
                <p class="dis_inb capitalize fs_18r fat">
                  {{ $t("msg.buy_pix") }}
                </p>
                <br />
                <p class="dis_inb fs_small">
                  {{ $t("msg.buy_pix_info") }}
                </p>
              </div>
            </div>

            <div v-if="modalPIX">
              <modalBuyBluePIX
                @toggleModalBuyBluePIX="showModalPIX()"
                :blueAmount="bluAmount"
                :usdtAmount="bluTusd"
              />
            </div>

            <div
              v-if="languageSelected == 'pt'"
              class="container_coin_select_buy tal_c"
              @click="selectCurrency('OTC')"
              :class="{
                selected: selectedCurrency == 'OTC',
              }"
            >
              <div class="buy_coin_icon background_">
                <span
                  v-html="iconSets.otc_user_icon"
                  class="icon_class_3"
                  style="fill: white; color: white"
                ></span>
              </div>
              <p class="dis_inb capitalize text_lg">OTC (Over-the-counter)</p>
            </div>
          </div>
        </div>

        <div>
          <h2 class="fs_05r fat">{{ $t("msg.important") }}!</h2>
          <div class="mw80 combo_0" style="display: flex">
            <input
              type="checkbox"
              id="confirTerms"
              value="confirTerms"
              v-model="confirTerms"
              style="width: 30px; height: 30px"
            />

            <label for="confirTerms">
              <p class="tal_c fs_00r">{{ $t("msg.understand_and_agree") }}</p>
            </label>
          </div>

          <div class="column custom_flex_column" style="padding: 40">
            <button
              v-if="
                (!loadingButton && selectedCurrency == 'BTC') ||
                (!loadingButton && selectedCurrency == 'ETH') ||
                (!loadingButton && selectedCurrency == 'USDT')
              "
              class="
                general_button_large
                sub_green_lt_bg
                main_white_fill
                text_lg
                upper
                fat
              "
              :class="{
                disabled_btn_custon: selectedCurrency == '' || !confirTerms,
              }"
              @click="callNextState()"
            >
              {{ $t("msg.confirm") }}
            </button>

            <button
              v-if="!loadingButton && selectedCurrency == 'OTC'"
              class="
                general_button_large
                sub_green_lt_bg
                main_white_fill
                text_lg
                upper
                fat
              "
              :class="{
                disabled_btn_custon: selectedCurrency == '' || !confirTerms,
              }"
              @click="changeStepOtc()"
            >
              {{ $t("msg.confirm") }}
            </button>

            <button
              v-if="selectedCurrency == ''"
              class="
                general_button_large
                sub_green_lt_bg
                main_white_fill
                text_lg
                upper
                disabled_btn_custon
                fat
              "
            >
              {{ $t("msg.confirm") }}
            </button>

            <button
              v-if="loadingButton"
              class="
                general_button_large
                sub_green_lt_bg
                main_white_fill
                text_lg
                upper
              "
              style="cursor: not-allowed"
            >
              <Loading />
            </button>
          </div>
        </div>
      </div>

      <div class="buy_blu_modal_warning" v-if="stepForm && !formFinish">
        <a class="modal_warning_close close" @click="backReferStep()">X</a>
        <div
          class="column custom_flex_column"
          style="margin-top: 5vh; padding: 0px 70px 0px 70px !important"
        >
          <p>{{ $t("msg.otc_info") }}</p>
          <div class="form_block flex_input_label">
            <label class="fat top_label">{{ $t("msg.name") }}</label>
            <input v-model="name" type="text" class="form_white_border" />
          </div>

          <div class="form_block flex_input_label">
            <label class="fat top_label">E-mail</label>
            <input
              v-model="email"
              type="text"
              class="form_white_border"
              disabled
            />
          </div>

          <div class="form_block flex_input_label">
            <label class="fat top_label">{{ $t("msg.phone") }}</label>
            <VuePhoneNumberInput
              v-model="phone"
              :border-radius="0"
              :translations="{
                countrySelectorLabel: $t('msg.phone_code'),
                phoneNumberLabel: $t('msg.phone'),
              }"
            />
          </div>

          <div class="form_block flex_input_label">
            <label class="fat top_label">BLUE {{ $t("msg.quantity") }}</label>
            <input
              v-model="bluAmount"
              v-on:keypress="isNumber()"
              class="form_white_border"
            />
          </div>
        </div>
        <div
          class="column custom_flex_column"
          style="margin-top: 5vh; padding: 0px 70px 0px 70px !important"
        >
          <button
            v-if="!loadingButton"
            style="width: 100%"
            class="
              general_button_large
              sub_green_lt_bg
              main_white_fill
              text_lg
              upper
            "
            @click="sendEmailOtc()"
          >
            {{ $t("msg.send") }}
          </button>
          <button
            v-if="loadingButton"
            class="
              general_button_large
              sub_green_lt_bg
              main_white_fill
              text_lg
              upper
            "
            style="cursor: not-allowed"
          >
            <Loading />
          </button>
        </div>
      </div>

      <div class="buy_blu_modal_warning" v-if="stepSellerInfoUid">
        <!-- <a class="modal_warning_close close" @click="backReferStep()">X</a> -->
        <div
          class="column custom_flex_column"
          style="margin-top: 5vh; padding: 0px 70px 0px 70px !important"
        >
          <p>{{ $t("msg.seller_buy") }}</p>
          <div class="form_block flex_input_label">
            <label class="fat top_label">UID</label>
            <div style="display: flex">
              <input
                v-model="uid"
                type="text"
                class="form_white_border"
                style="width: 85%; height: 100%"
              />
              <div
                style="
                  width: 15%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100%;
                "
                class="icon_class_1"
                variant="outline-primary"
                @click="findMember()"
              >
                <div
                  class="button is-link"
                  v-html="iconSets.search_default"
                  style="color: white"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div
          style="margin-top: 5vh; padding: 0px 70px 0px 70px !important"
          :style="foundMember ? 'opacity:1' : 'opacity:0'"
        >
          <p>{{ $t("msg.found_member") }}</p>
          <p>{{ $t("msg.name") }}: {{ memberFound.name }}</p>
          <p>E-mail: {{ memberFound.email }}</p>
        </div>

        <div
          class="column custom_flex_column"
          style="margin-top: 5vh; padding: 0px 70px 0px 70px !important"
        >
          <button
            v-if="foundMember == ''"
            class="
              general_button_large
              sub_green_lt_bg
              main_white_fill
              text_lg
              upper
              disabled_btn_custon
              fat
            "
          >
            {{ $t("msg.confirm") }}
          </button>

          <button
            v-else-if="!loadingButton"
            style="width: 100%"
            class="
              general_button_large
              sub_green_lt_bg
              main_white_fill
              text_lg
              upper
            "
            @click="postOtcPurchase()"
          >
            {{ $t("msg.confirm") }}
          </button>
          <button
            v-else-if="loadingButton"
            class="
              general_button_large
              sub_green_lt_bg
              main_white_fill
              text_lg
              upper
            "
            style="cursor: not-allowed"
          >
            <Loading />
          </button>
        </div>
      </div>

      <div class="buy_blu_modal_warning" v-if="formFinish">
        <a class="modal_warning_close close" @click="firstStep()">X</a>
        <div
          class="column custom_flex_column"
          style="
            margin-top: 10vh;
            padding: 0px 70px 0px 70px !important;
            text-align: center;
          "
        >
          <p style="font-size: 30px">{{ $t("msg.thank_you") }}!</p>
          <p style="font-size: 25px">{{ $t("msg.otc_thank_msg") }}</p>
        </div>
      </div>
    </div>

    <div v-else style="height: 100%; border-radius: 8px 8px 8px 8px">
      <div v-if="loading" style="height: 100%; border-radius: 8px 8px 8px 8px">
        <LoadingBuyBlu />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { TheMask } from "vue-the-mask";
import LoadingBuyBlu from "../../../public/LoadingBuyBlu";
import Loading from "../../../public/Loading";
import ModalBuyBluePIX from "../../../modals/modalBuyBluePIX.vue";

import btcImg from "../../../../assets/images/coins/bitcoin-buyBlue.svg";
import ethImg from "../../../../assets/images/coins/ethereum-buyBlue.svg";
import usdtImg from "../../../../assets/images/coins/tether-buyBlue.svg";
import pixImg from "../../../../assets/images/coins/pix-buyBlue.svg";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import Swal from "sweetalert2";

export default {
  props: ["fees"],
  created() {
    this.$store.dispatch("updateCurrencies").then((resp) => {
      this.getMinBlu();
    });

    this.checkCountry();
    this.getPurchases();
  },
  mounted() {},
  data: () => ({
    formFinish: false,
    loading: true,
    loadingButton: false,
    minBlue: null,
    minBtc: 0.02,
    bluAmount: "0.00",
    firstLoad: true,
    bluTusd: "",
    previewData: "...",
    selectedAccount: "",
    locked: "",
    bluAmountValid: false,
    toolTipCharity: false,
    maxBluAmount: 99999999999,
    tooltipBonus: false,
    tooltipStratum: false,
    modalWarning: false,
    stepSellerInfoUid: false,
    purchaseReferral: "",
    newPurchaseReferal: "",
    selectedCurrency: "",
    referStep: false,
    stepForm: false,
    confirTerms: false,
    btc: "",
    blu: "",
    uid: "",
    trade: "",
    temporaryBalance: 0,
    selectWay: "",
    skipReferral: false,
    foundMember: false,
    blockMsg: false,
    currencyList: [
      {
        name: "Bitcoin",
        symbol: "BTC",
        isAvailable: "",
        img: btcImg,
      },
      {
        name: "Ethereum",
        symbol: "ETH",
        isAvailable: "",
        img: ethImg,
      },
      {
        name: "Tether",
        symbol: "USDT",
        isAvailable: "",
        img: usdtImg,
      },
    ],

    name: "",
    email: "",
    phone: "",
    purchases: "",
    isMobile: "",
    memberFound: "",
    modalPIX: false,
  }),
  components: {
    TheMask,
    Loading,
    VuePhoneNumberInput,
    LoadingBuyBlu,
    Swal,
    ModalBuyBluePIX,
  },
  mounted() {
    window.addEventListener("resize", this.checkIfMobile);
    this.checkIfMobile();
  },
  methods: {
    async getPurchases() {
      try {
        let resp = await this.$store.dispatch("getPurchases");
        this.purchases = resp.data;
      } catch (e) {
        this.logError(e);
      }
    },

    async findMember() {
      let uid = this.uid;

      let resp = await this.$store.dispatch("getMemberByUID", uid);
      if (resp.status == 200) {
        if (resp.data.length > 0) {
          this.foundMember = true;
          this.memberFound = resp.data[0];
        } else {
          this.notifyDanger(this.$t("msg.member_not_found"), 5000);
        }
      } else {
        this.notifyDanger(this.$t("msg.member_not_found"), 5000);
      }
    },

    async postOtcPurchase() {
      if (this.bluAmount == "" || this.uid == "") {
        this.notifyDanger(this.$t("msg.required_fields_amount_uid"), 5000);
      } else {
        let body = {
          memberUID: this.memberFound.uid,
          sourceCurrency: this.selectedCurrency,
          targetAmount: parseFloat(this.bluAmount),
        };

        await this.$store
          .dispatch("postSellerPurchase", body)
          .then((r) => {
            this.$emit(
              "callNextState",
              this.paymentMode,
              this.bluTusd.toFixed(2)
            );

            if (r.status == 200) {
              this.notifySuccess(this.$t("msg.purchase_success"), 5000);
              location.reload();
            }
          })
          .catch((e) => {
            alert(e);
            this.loadingButton = false;
          });
      }
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 1200) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },

    checkTranscationStatus() {
      let trades = this.purchases;
      for (let i in trades) {
        if (trades[i].status == "waiting") {
          this.purchaseWaiting = trades[i];
          this.transactionState = 1;
        }
      }
    },

    checkCountry() {
      console.log();
    },

    firstStep() {
      this.loadingButton = false;
      this.selectWay = false;
      this.modalWarning = false;
      this.stepForm = false;
      this.formFinish = false;
    },

    fillFieldsForm() {
      this.name = this.member.name;
      this.email = this.member.email;
      this.phone = this.member.phone;
      this.bluAmount;
    },

    async sendEmailOtc() {
      this.loadingButton = true;
      if (!this.name || !this.email || !this.bluAmount || !this.phone) {
        alert(this.$t("msg.form_error_fields"));
        this.loadingButton = false;
      } else {
        let email = {
          to: "edgar@stratum.bt",
          subject: "OTC - Blu",
          message: `Name ${this.name} || e-mail: ${this.email} || phone: ${this.phone} || BLU Quantity: ${this.bluAmount}`,
        };

        this.$store.dispatch("genericMail", email).then(
          (resp) => {
            if (resp.status == 200) {
              this.formFinish = true;
              this.loadingButton = false;
            }
          },
          (error) => {
            alert(error.message);
            console.log(error);
            this.loadingButton = false;
          }
        );
      }
    },

    toggleLock() {
      this.locked = !this.locked;
    },

    showToolTipCharity() {
      this.toolTipCharity = true;
    },
    hideToolTipCharity() {
      this.toolTipCharity = false;
    },

    callReferStep() {
      this.modalWarning = false;
      this.stepForm = true;
    },

    backReferStep() {
      this.stepForm = false;
      this.modalWarning = true;
    },

    callPurchasePreview() {},

    getCurrencyStatus() {
      for (let i = 0; i < this.currencyList.length; i++) {
        for (let j = 0; j < this.currencies.length; j++) {
          if (this.currencyList[i].symbol == this.currencies[j].symbol) {
            console.log(
              this.currencyList[i].symbol,
              this.currencies[j].symbol,
              this.currencies[j].isAvailable
            );
            this.currencyList[i].isAvailable = this.currencies[j].isAvailable;
          }
        }
      }
    },

    selectCurrency(selectedCurrency) {
      this.selectedCurrency = selectedCurrency;
    },

    sendToSite() {
      window.open("https://pix.xchange.ee/?currency=BLUE");
    },

    getMinBluXUsdt() {
      let result = this.bluValue[0].tradeMinimal;
      return result.toFixed();
    },

    getMinBlu() {
      let bluMin = this.bluValue[0].tradeMinimal / this.bluValue[0].value;
      bluMin = this.roundUp(bluMin, 6);
      this.minBlue = bluMin;
      if (this.firstLoad) {
        this.setMin();
      }
    },
    setMin() {
      this.bluAmount = this.minBlue;
      this.firstLoad = false;
    },
    getTemporaryBalance() {
      this.temporaryBalance = this.btcAccount.balance;
    },

    validateAmount() {
      this.bluAmountValid = false;
      let indices = [];
      let amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
    },

    modifyBluAmount(modifier) {
      if (this.bluAmount == "") {
        this.bluAmount = this.minBlue;
      }

      this.bluAmount = parseFloat(this.bluAmount);
      if (
        this.bluAmount == false ||
        this.bluAmount < this.minBlue ||
        this.bluAmount == ""
      ) {
        this.bluAmount = this.minBlue;
      } else {
        let vm = this;
        if (modifier == "-" && this.bluAmount > 0) {
          let result = this.bluAmount - 1;
          if (result > this.minBlue) {
            result = vm.roundUp(result, 3);
            vm.bluAmount = result;
          } else {
            this.bluAmount = this.minBlue;
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount);
          let result = vm.roundUp(this.bluAmount + 1, 3);
          this.bluAmount = result;
        }
      }
    },
    roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },

    showToolTipBonus() {
      this.tooltipBonus = true;
    },

    hideToolTipBonus() {
      this.tooltipBonus = false;
    },

    showToolTipStratum() {
      this.tooltipStratum = true;
    },

    hideToolTipStratum() {
      this.tooltipStratum = false;
    },

    blockPurchaseInfo() {
      this.blockMsg = true;
    },

    changeModalWarningState(state, mode) {
      this.selectWay = "crypto";
      this.paymentMode = mode;
      this.modalWarning = state;
      if (mode == "slips") {
        this.callNextState();
      }

      this.selectWay = false;
    },

    changeModalSelectWay(state, mode) {
      this.paymentMode = mode;
      this.selectWay = state;
    },

    forceStateChange() {
      if (this.transactionState < 3) {
        this.transactionState = this.transactionState + 1;
      } else {
        this.transactionState = 0;
      }
    },

    postTrade() {
      let value = this.bluAmount;
      let form = {
        sourceCurrency: this.selectedCurrency,
        targetAmount: parseFloat(value),
      };

      if (this.purchaseReferral != "") {
        form.referCode = this.purchaseReferral;
      }

      if (this.paymentMode == "slips") {
        form.sourceCurrency = "BRL";
      }

      return this.$store.dispatch("postTrade", form);
    },

    changeStepOtc() {
      this.fillFieldsForm();

      this.modalWarning = false;
      this.stepForm = true;
    },

    async callNextState() {
      if (this.selectedCurrency == "USDT") {
        await Swal.fire({
          html:
            `<span style="font-size:1.25em;">` +
            this.$t("msg.info_usdt_blue_purchase") +
            `</span>`,
          icon: "warning",
          confirmButtonText: this.$t("msg.i_understand"),
          confirmButtonColor: "#4e4f99",
        });
      }

      if (this.member.level == "seller") {
        Swal.fire({
          title: this.$t("msg.purchase_confirmation", 1),
          html: `${this.$t("msg.purchase_seller_to_user")}`,
          icon: "question",
          showCancelButton: true,
          cancelButtonColor: "#3A8CEA",
          confirmButtonColor: "#0CA2B5",
          confirmButtonText: this.$t("msg.yes"),
          cancelButtonText: this.$t("msg.no"),
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.stepSellerInfoUid = true;
          } else {
            this.loadingButton = true;

            let lastCharacter = this.bluAmount[this.bluAmount.length - 1];

            if (lastCharacter === ".") {
              let x = this.bluAmount.length - 1;
              this.bluAmount = this.bluAmount.slice(0, x);
            }

            if (parseFloat(this.bluAmount) > parseFloat(this.minBlue - 0.001)) {
              await this.postTrade()
                .then((r) => {
                  // this.$emit(
                  //   "callNextState",
                  //   this.paymentMode,
                  //   this.bluTusd.toFixed(2)
                  // );

                  location.reload();
                })
                .catch((e) => {
                  Swal.fire({
                    icon: "error",
                    title: this.$t("msg.error"),
                    text: this.$t("msg.error_xgateway"),
                  });
                  console.log(e);
                  this.loadingButton = false;
                });
            } else {
              this.notifyError(this.$t("msg.minimum_amount_required"), 5000);
            }
          }
        });
      } else {
        this.loadingButton = true;

        let lastCharacter = this.bluAmount[this.bluAmount.length - 1];

        if (lastCharacter === ".") {
          let x = this.bluAmount.length - 1;
          this.bluAmount = this.bluAmount.slice(0, x);
        }

        if (parseFloat(this.bluAmount) > parseFloat(this.minBlue - 0.001)) {
          await this.postTrade()
            .then((r) => {
              this.$emit(
                "callNextState",
                this.paymentMode,
                this.bluTusd.toFixed(2)
              );
            })
            .catch((e) => {
              Swal.fire({
                icon: "error",
                title: this.$t("msg.error"),
                text: this.$t("msg.error_xgateway"),
              });
              console.log(e);
              this.loadingButton = false;
            });
        } else {
          this.notifyError(this.$t("msg.minimum_amount_required"), 5000);
        }
      }
    },

    showModalPIX() {
      console.log(this.bluAmount, "aqqq");
      console.log(this.bluTusd);
      this.modalPIX = !this.modalPIX;
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        this.callPurchasePreview();
        return true;
      }
    },
  },
  computed: {
    ...mapGetters([
      "member",
      "bluAccount",
      "btcAccount",
      "usdtAccount",
      "bluValue",
      "btcValue",
      "currencies",
      "languageSelected",
      "minimumInvestiment",
    ]),
  },
  watch: {
    btcValue: function () {
      this.getMinBlu();
    },
    bluAmount: function () {
      this.validateAmount();
    },

    minBlue: function () {
      if (this.bluAmount < this.minBlue) {
        this.setMin();
      }
    },
    currencies: function () {
      this.getCurrencyStatus();
    },

    purchases: function () {
      this.checkTranscationStatus();
      this.loading = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/private/landing/base_buy_blu/BaseBuyBluBuy.vue